


import { CloseOutlined } from "@ant-design/icons";
import { Modal } from "antd";

const CommonModal = ({
  open,
  onClose,
  content,
  width = 500,
  title,
  subTitle,
  sampleFile,
}) => {
  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      width={width}
      centered
      
      closeIcon={
        <div
          style={{
            display: "block",
            width: "54px",
            height: "54px",
            fontSize: "16px",
            fontStyle: "normal",
            lineHeight: "54px",
            textAlign: "center",
            textTransform: "none",
            textRendering: "auto",
            marginTop: "20px",
          }}
        >
          <CloseOutlined />
        </div>
      }
      title={
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
            position: "sticky",
            top: "0px",
            zIndex: "99",
            backgroundColor: "white",
          }}
        >
          <div style={{ display: "flex", flexDirection: "column" }}>
            <h1
              style={{
                fontFamily: "Inter",
                fontSize: "20px",
                fontWeight: "600",
                color: "#101828",
                margin: "0",
              }}
            >
              {title}
            </h1>
            <p style={{ margin: "0", color: "#667085" }}>{subTitle}</p>
          </div>
          <div style={{ display: "flex", alignItems: "center", gap: "18px" }}>
            {sampleFile && (
              <a
                href={sampleFile}
                download="SampleCSV.csv"
                style={{
                  fontSize: "14px",
                  textDecoration: "underline",
                  color: "#3166FF",
                 marginRight:'18px'
                }}
              >
                Sample CSV
              </a>
            )}
          </div>
        </div>
      }
    >
      {content}
    </Modal>
  );
};

export default CommonModal;



